(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('Hospitalization', Hospitalization);

    Hospitalization.$inject = ['$resource', 'DateUtils'];

    function Hospitalization ($resource, DateUtils) {
        var resourceUrl =  'api/hospitalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateIssue = DateUtils.convertLocalDateFromServer(data.dateIssue);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.dateIssue = DateUtils.convertLocalDateToServer(data.dateIssue);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.dateIssue = DateUtils.convertLocalDateToServer(data.dateIssue);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
